import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SunBucksConfigService } from '../services/sun-bucks-config.service';

/**
 * Logs HTTP errors that originate from the Sun Bucks API.
 * Requests to other origins (MSAL, review-form, etc.) are passed through
 * without modification.
 */
@Injectable()
export class SunBucksHttpErrorInterceptor implements HttpInterceptor {

    constructor(private readonly configService: SunBucksConfigService) { }

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        // Config not loaded yet — skip interceptor
        if (!this.configService.isLoaded) {
            return next.handle(req);
        }

        // Not a sun-bucks API request — skip interceptor
        if (!req.url.startsWith(this.configService.apiBaseUrl)) {
            return next.handle(req);
        }

        return next.handle(req).pipe(
            catchError((err: unknown) => {
                if (err instanceof HttpErrorResponse) {
                    console.error(
                        `[SunBucksHttpErrorInterceptor] ${req.method} ${req.urlWithParams} — HTTP ${err.status}`,
                        err.error ?? err.message
                    );
                }
                return throwError(() => err);
            })
        );
    }
}
